export default __webpack_public_path__ + "static/media/VitaminB12.5b51de4f.svg";